<template>
  <div id="app">
    <Subtitler/>
  </div>
</template>

<script>
import Subtitler from './components/Subtitler.vue'


export default {
  name: 'App',
  components: {
    Subtitler
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Material+Icons");
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 20px;
}
</style>
